import { render, staticRenderFns } from "./LControlInfo.vue?vue&type=template&id=2b6be67a&scoped=true&"
import script from "./LControlInfo.vue?vue&type=script&lang=js&"
export * from "./LControlInfo.vue?vue&type=script&lang=js&"
import style0 from "./LControlInfo.vue?vue&type=style&index=0&id=2b6be67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6be67a",
  null
  
)

export default component.exports